import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";

@Injectable()
export class MessageBusService {
    channel: BehaviorSubject<any> = new BehaviorSubject({});

    init(): void {
        // noop
    }

    send(id: string, fn: string, args?: Array<any>): void {
        this.channel.next({
            to: id,
            fn,
            args: args || []
        });
    }

    listen(id: string, component, takeUntil?: Observable<void>): void {

        if (!takeUntil) {
            takeUntil = component.ngUnsubscribe;
        }

        if (!takeUntil) {
            throw new Error("takeUntil cannot be null. takeUntil must be specified as an argument or ngUnsubscribe must be present on the 'component'");
        }

        this.channel.takeUntil(takeUntil).subscribe(message => {
            if (message.to === "*" || message.to === id) {
                let result;
                if (typeof component[message.fn] === "function") {

                    try {
                        result = component[message.fn].apply(component, message.args || []);
                    } catch (e) {
                        console.error(`messagebus caught error calling '${message.to}.${message.fn}()`, e);
                    }

                    if (result instanceof Promise) {
                        result.then(
                            () => {
                                // no opp
                            },
                            error => {
                                console.error("message bus listener caught an error from promise", error);
                            }
                        );
                    }

                } else {
                    console.warn(`message received by "${id}" cannot be handled because function "${message.fn}" does not exist`);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/core/services/message-bus/message-bus.service.ts